import React from "react";
import { clearRetailer, getRetailer } from "../../../actions/retailers";
import { getDefaultState, RetailersStore } from "../../../stores/retailers";
import M from "../../../strings";
import { format, optional } from "../../../utils/lang";
import { Screen } from "../../components/layout";
import { ACTION_TYPES } from "../../components/mobile/actions";
import MobileLayout from "../../components/mobile/layout";
import Secure from "../../components/secure";
import { connect } from "../../utils/aj";
import * as ui from "../../utils/ui";
import { isNotEmpty } from "../../../framework/utils";
import * as RetailerUtils from "../../utils/retailers";
import _ from "underscore";
import { SurveySummary } from "../../components/mobile/surveys";
import { showDialog } from "../../../actions/dialog";
import StoreTrendsDownloadDialog from "./storeTrendsDownloadDialog";

export default class StoreDetails extends Screen {

    constructor(props) {
        super(props);
        connect(this, RetailersStore, getDefaultState());
    }

    componentDidMount() {
        const retailerId = this.props.storeId;
        getRetailer({id: retailerId});
    }

    componentWillUnmount() {
        clearRetailer();
    }

    viewSurvey(surveySummary) {
        ui.navigate("/app/survey/" + surveySummary.survey.id);
    }

    downloadTrends() {
        showDialog({
            mobile: true,
            getContent: () => (<StoreTrendsDownloadDialog
                    store={this.state.currentRetailer?.store}
                />)
        })
    }

    render() {
        const retailer = optional(this.state.currentRetailer, {}),
            store = optional(retailer.store, {}),
            description = RetailerUtils.getStoreDescription(store),
            address = RetailerUtils.formatStoreAddress(store),
            surveySummaries = optional(retailer.surveySummaries, []),
            leftActions=[
                {
                    id: "back",
                    type: ACTION_TYPES.ICON,
                    icon: "arrow_back",
                    onClick: () => ui.back(),
                },
            ],
            rightActions=isNotEmpty(surveySummaries) ? [
                {
                    id: "download",
                    type: ACTION_TYPES.ICON,
                    icon: "download",
                    onClick: this.downloadTrends.bind(this),
                }
            ] : [];

        return (
            <Secure>
                <MobileLayout
                    title={description || M("store")}
                    leftActions={leftActions}
                    rightActions={rightActions}
                >
                    {isNotEmpty(this.state.currentRetailer) && (
                        <div
                            className="store-details"
                        >
                            <div
                                className="store-details__info"
                            >
                                <div
                                    className="store-details__title"
                                >
                                    {description}
                                </div>
                                <div
                                    className="store-details__text"
                                >
                                    {address}
                                </div>
                            </div>
                            <div
                                className="store-details__surveys"
                            >
                                <div
                                    className="store-details__surveys-title"
                                >
                                    {format(M("retailersSurveyHistoryWithNumber"), surveySummaries.length)}
                                </div>
                                <div
                                    className="store-details__surveys-items"
                                >
                                    {isNotEmpty(surveySummaries) ? (_.map(surveySummaries, item => {
                                        return (<div
                                            key={"store-details-survey-" + item.survey.id}
                                            className="store-details__surveys-item"
                                        >
                                            <SurveySummary
                                                surveySummary={item}
                                                onClick={this.viewSurvey.bind(this)}
                                            />
                                        </div>)
                                    })) : (<div
                                        className="p-5 text-center"
                                    >
                                        {M("noSurveys")}
                                    </div>)}
                                </div>
                            </div>
                        </div>
                    )}
                </MobileLayout>
            </Secure>
        )
    }
}